var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M475.79 277.045C462.296 317.945 433.225 362.77 390.444 377.362C325.803 399.416 320.028 452.431 202.708 452.069C184.416 452.014 167.437 450.099 151.772 446.599C143.351 444.719 135.307 442.369 127.652 439.598C58.153 414.528 20.101 354.907 14.671 291.197C7.51605 207.403 64.54 165.128 101.7 140.229C138.86 115.33 181.231 22.777 296.567 22.227C314.152 22.151 331.766 23.874 348.922 27.82C388.085 36.811 428.38 58.49 452.586 91.522C454.403 94.004 456.143 96.548 457.816 99.144C490.464 149.943 494.191 221.286 475.79 277.045Z",
    fill: "#3AF2AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M475.79 277.045C462.296 317.945 433.225 362.77 390.444 377.362C325.803 399.416 320.028 452.431 202.708 452.069C184.416 452.014 167.437 450.099 151.772 446.599C143.351 444.719 135.307 442.369 127.652 439.598C58.153 414.528 20.101 354.907 14.671 291.197C7.51605 207.403 64.54 165.128 101.7 140.229C138.86 115.33 181.231 22.777 296.567 22.227C314.152 22.151 331.766 23.874 348.922 27.82C388.085 36.811 428.38 58.49 452.586 91.522C454.403 94.004 456.143 96.548 457.816 99.144C490.464 149.943 494.191 221.286 475.79 277.045Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M303 45H254V79H303V45Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M254 45L278.5 62L303 45",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M336.342 34H306.554V55.3228H336.342V34Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M306.554 34L321.448 44.6618L336.342 34",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3469 459.449H483.589",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M432.412 111.329H87.3936C82.8025 111.329 79.0806 115.051 79.0806 119.642V388.222C79.0806 392.813 82.8025 396.535 87.3936 396.535H296.663H307H317.432H432.413C437.004 396.535 440.726 392.813 440.726 388.222V119.642C440.726 115.051 437.004 111.329 432.412 111.329Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M438.47 103H93.4504C88.8594 103 85.1375 106.722 85.1375 111.313V379.892C85.1375 384.483 88.8594 388.205 93.4504 388.205H302.72H313.5H323.489H438.47C443.061 388.205 446.783 384.483 446.783 379.892V111.313C446.784 106.722 443.062 103 438.47 103Z",
    fill: "#40B0D5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M438.47 103H93.4504C88.8594 103 85.1375 106.722 85.1375 111.313V379.892C85.1375 384.483 88.8594 388.205 93.4504 388.205H302.72H313H323.489H438.47C443.061 388.205 446.783 384.483 446.783 379.892V111.313C446.784 106.722 443.062 103 438.47 103Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M364.796 141.373H289.817C283.426 131.414 273.563 125.009 262.508 125.009C251.446 125.009 241.578 131.414 235.185 141.373H160.202C155.128 141.373 151 146.475 151 152.747V347.635C151 353.907 155.128 359.009 160.202 359.009H364.798C369.872 359.009 374 353.907 374 347.635V152.748C373.998 146.475 369.871 141.373 364.796 141.373Z",
    fill: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M368.306 353.009H163.694C158.892 353.009 155 348.185 155 342.233V146.786C155 140.834 158.892 136.009 163.694 136.009H368.306C373.108 136.009 377 140.834 377 146.786V342.233C377 348.185 373.108 353.009 368.306 353.009Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M316.701 324.009H215.299C210.715 324.009 207 321.786 207 319.044V306.975C207 304.232 210.715 302.009 215.299 302.009H316.701C321.285 302.009 325 304.232 325 306.975V319.044C325 321.786 321.285 324.009 316.701 324.009Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M300.413 155.026C300.413 166.012 295.273 175.811 287.237 182.102C281.392 186.722 273.986 189.469 265.969 189.469C257.934 189.469 250.529 186.722 244.683 182.102C236.647 175.81 231.506 166.012 231.506 155.026C231.506 135.985 246.929 120.564 265.968 120.564C284.992 120.564 300.413 135.985 300.413 155.026Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M280.35 149.627C280.35 141.682 273.909 135.241 265.964 135.241C258.019 135.241 251.578 141.681 251.578 149.627C251.578 157.572 258.018 164.013 265.964 164.013C273.909 164.013 280.35 157.572 280.35 149.627Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M287.237 182.101C281.391 186.722 273.986 189.469 265.969 189.469C257.933 189.469 250.529 186.722 244.683 182.101C246.816 172.322 255.54 164.991 265.969 164.991C276.38 164.992 285.103 172.322 287.237 182.101Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M322.917 203.674H209.004C207.899 203.674 207.004 204.57 207.004 205.674V220.217C207.004 221.321 207.899 222.217 209.004 222.217H322.917C324.021 222.217 324.917 221.321 324.917 220.217V205.674C324.917 204.57 324.021 203.674 322.917 203.674Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M322.917 236.217H209.004C207.899 236.217 207.004 237.112 207.004 238.217V252.759C207.004 253.864 207.899 254.759 209.004 254.759H322.917C324.021 254.759 324.917 253.864 324.917 252.759V238.217C324.917 237.112 324.021 236.217 322.917 236.217Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M322.917 268.759H209.004C207.899 268.759 207.004 269.655 207.004 270.759V285.302C207.004 286.406 207.899 287.302 209.004 287.302H322.917C324.021 287.302 324.917 286.406 324.917 285.302V270.759C324.917 269.655 324.021 268.759 322.917 268.759Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0431 292.735H23.7031V318.748H60.0431V292.735Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7031 292.735L41.8731 305.741L60.0421 292.735",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4);
export default __webpack_public_path__ + "static/media/step-4.f3fc67171133139fc3831b1e2f0a8b5d.svg";
export { ForwardRef as ReactComponent };